// checks to see if the current browser being used is chrome
export const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)

export const isFirefox = typeof InstallTrigger !== 'undefined'

export const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]' })(!window === ['safari'] || (typeof safari !== 'undefined' && window.safari.pushNotification))

export const isIE = false || !!document.documentMode

export const isEdge = !isIE && !!window.StyleMedia

export const isEdgeChromium = isChrome && (navigator.userAgent.indexOf('Edg') !== -1)

export const validateLinkID = (str) => {
  const linkFormatPattern = /^([a-zA-Z0-9]){8}$/
  if (!str || !linkFormatPattern.test(str)) { return false }

  return true
}
